/*
 * Copyright (c) Volvo Group. All rights reserved.
 * SPDX-License-Identifier: ISC
 */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { defaultLanguage, defaultNS, resources } from "./i18Config";

export const i18nInit = () => {
  i18n.use(initReactI18next).init({
    lng: defaultLanguage,
    fallbackLng: defaultLanguage,
    load: "languageOnly",
    ns: defaultNS,
    resources,
    defaultNS,
  });

  return i18n;
};
